import React from 'react';
import { createRoot } from 'react-dom/client';
import { HashRouter } from 'react-router-dom';
import App from './App.jsx';
import './styles.css';
import './activity.css';
import './evolution.css';
import './reports.css';
import './features/pei/pei-smart.css';
import './features/pei/goal-links.css';
import './features/sessions/session-styles.css';
import './responsive-wide.css';

createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <HashRouter>
      <App />
    </HashRouter>
  </React.StrictMode>
);
